import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
  CONTENT_TYPE_EXTERNAL_LINK,
  CONTENT_TYPE_IMAGE,
  CONTENT_TYPE_INTERNAL_LINK,
  CONTENT_CONTACT_LINK,
  CONTENT_TYPE_TEXT,
  CONTENT_TYPE_MAIL_LINK,
  CONTENT_TYPE_YOUTUBE
} from '../../helpContent/constants';
import {captureError} from '../../utils/log';

class HelpContentDetails extends Component {
  getContentComponent(content) {
    switch (content.type) {
      case CONTENT_TYPE_TEXT:
        return (
          <div className={`row${content.adornment ? ' mt-5' : ' mt-4'}`}>
            <strong className="col-1 information-primary no-wrap font-size-xxl">{content.adornment}</strong>
            <span className="col-11 inline-container align-items-center">{content.value}</span>
          </div>
        );
      case CONTENT_TYPE_INTERNAL_LINK:
        return (
          <div className={`row${content.adornment ? ' mt-5' : ' mt-4'}`}>
            <strong className="col-1 information-primary no-wrap font-size-xxl">{content.adornment}</strong>
            <div className="col-11 inline-container align-items-center">
              <a
                href={content.value}
                target="_blank"
                rel="noopener noreferrer"
              >
                {content.label}
              </a>
            </div>
          </div>
        );
      case CONTENT_TYPE_EXTERNAL_LINK:
        return (
          <div className={`row${content.adornment ? ' mt-5' : ' mt-4'}`}>
            <strong className="col-1 information-primary no-wrap font-size-xxl">{content.adornment}</strong>
            <a
              className="col-11 inline-container align-items-center"
              href={content.value}
              target="_blank"
              rel="noopener noreferrer"
            >
              {content.label}
            </a>
          </div>
        );
      case CONTENT_TYPE_MAIL_LINK:
        return (
          <div className={`row${content.adornment ? ' mt-5' : ' mt-4'}`}>
            <strong className="col-1 information-primary no-wrap font-size-xxl">{content.adornment}</strong>
            <a
              className="col-11 inline-container align-items-center"
              href={content.value}
              target="_blank"
              rel="noopener noreferrer"
            >
              {content.label}
            </a>
          </div>
        );
      case CONTENT_TYPE_IMAGE:
        return (
          <div className={`row${content.adornment ? ' mt-5' : ' mt-4'}`}>
            <strong className="col-1 information-primary no-wrap font-size-xxl">{content.adornment}</strong>
            <div className="col-11 inline-container justify-content-center align-items-center">
              <img
                alt="screenshots"
                src={content.value}
                style={{maxWidth: '100%'}}
              />
            </div>
          </div>
        );
      case CONTENT_TYPE_YOUTUBE:
        return (
          <div className={`row${content.adornment ? ' mt-5' : ' mt-4'}`}>
            <strong className="col-1 information-primary no-wrap font-size-xxl">{content.adornment}</strong>
            <div className="col-11 inline-container justify-content-center align-items-center">
              <iframe
                height={315}
                src={content.value}
                frameBorder={0}
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="iframe-help-youtube-content"
              />
            </div>
          </div>
        );
      case CONTENT_CONTACT_LINK:
        return (
          <div className={`row${content.adornment ? ' mt-5' : ' mt-4'}`}>
            <strong className="col-1 information-primary no-wrap font-size-xxl">{content.adornment}</strong>
            <span
              className="col-11 inline-container align-items-center clickable"
              onClick={this.handleContactCustomerClick}
            >
              {content.label}
            </span>
          </div>
        );
      default:
        captureError(`Unsupported content type : ${content.type}`);
    }

    return null;
  }

  handleContactCustomerClick = event => {
    event.preventDefault();
    event.stopPropagation();
    return this.props.onOpenContactForm();
  };

  render() {
    const contents = this.props.content.contents
      .map((content, index) => (
        <React.Fragment key={`help-content-${index}`}>
          {this.getContentComponent(content)}
        </React.Fragment>
      ));

    return (
      <>
        <div className="px-5">
          <div className="row my-5">
            <div className="col-11 offset-1 information-primary">
              <h1 className="m-0">{this.props.content.title}</h1>
              <hr className="information-primary reverted"/>
            </div>
          </div>

          <div className="font-size-l">
            {contents}
          </div>
        </div>

      </>
    );
  }
}

HelpContentDetails.propTypes = {
  content: PropTypes.object.isRequired,
  onOpenContactForm: PropTypes.func.isRequired
};

export default HelpContentDetails;
